import { Field } from 'formik'
import React, { useCallback } from 'react'
import { TextAreaField } from '../../field'

interface Props {
  name: string
  label?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
}

export const TextAreaInput: React.FunctionComponent<Props> = ({ name, label, placeholder, disabled, required }) => {
  const validate = useCallback(
    (value: string | null): string | undefined => {
      if (required && (!value || !value.trim())) {
        return 'Kenttä on pakollinen'
      }
      return undefined
    },
    [required]
  )

  return (
    <Field
      component={TextAreaField}
      id={name}
      name={name}
      label={label}
      placeholder={placeholder}
      required={required}
      validate={validate}
      disabled={disabled}
    />
  )
}
